export default __webpack_public_path__ + "static/gift-guide-product-card-59224f06e62708b78dc6b89c577a4a34.png";